import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('No verification token found.'); return; }
    api.post('/api/auth/verify-email', { token })
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Verification failed. The link may have expired.');
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#fafafa] flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <h1 className="text-2xl font-semibold text-[#171717] mb-3" style={{ letterSpacing: '-0.8px' }}>
          {status === 'loading' && 'Verifying your email…'}
          {status === 'success' && 'Email verified!'}
          {status === 'error' && 'Verification failed'}
        </h1>
        {status === 'loading' && (
          <p className="text-sm text-[#808080]">Please wait a moment.</p>
        )}
        {status === 'success' && (
          <>
            <p className="text-sm text-[#4d4d4d] mb-6">Your email address has been confirmed. You're all set.</p>
            <Link to="/app" className="inline-block px-6 py-2.5 bg-[#171717] text-white text-sm font-medium rounded-md hover:bg-[#2e2e2e] transition-colors">
              Go to App
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="text-sm text-[#808080] mb-6">{message}</p>
            <Link to="/app" className="text-sm text-[#4d4d4d] hover:text-[#171717] underline">
              Back to App
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
